import api from './api';

export interface BusinessUnit {
  id: number;
  name: string;
  businessUnitKey: string;
  code: string;
  location: string;
  description: string;
  isActive: boolean;
  deletedAt?: string | null;
  deletedBy?: string | null;
}

export type BusinessUnitInput = Pick<BusinessUnit, 'name' | 'businessUnitKey' | 'code' | 'location' | 'description'>;

export const businessUnitService = {
  getAll: (includeDeleted = false) =>
    api.get<BusinessUnit[]>('/businessunits', { params: { includeDeleted } }),
  
  search: (search?: string, limit: number = 20) =>
    api.get<BusinessUnit[]>('/businessunits/search', { params: { search, limit } }),
  
  getById: (id: number) => api.get<BusinessUnit>(`/businessunits/${id}`),
  
  create: (data: BusinessUnitInput) =>
    api.post<BusinessUnit>('/businessunits', data),
  
  update: (id: number, data: BusinessUnitInput) =>
    api.put<BusinessUnit>(`/businessunits/${id}`, data),
  
  delete: (id: number) =>
    api.delete(`/businessunits/${id}`),

  restore: (id: number) =>
    api.post<BusinessUnit>(`/businessunits/${id}/restore`),
};
